import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TabsState } from './tab.reducer';

export const selectTabsState = createFeatureSelector<TabsState>('tabbing');

export const getTabs = createSelector(selectTabsState, state => state.tabs);

export const getActiveTabId = createSelector(selectTabsState, state => state.activeTabId);

export const getActiveTab = createSelector(selectTabsState, state => {
  const activeTab = state.tabs.find(tab => tab.route === state.activeTabId);
  return activeTab ? { ...activeTab } : null;
});
